import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IInitialState{
    selectedGenericRadioBtn: string
}

const defaultRadioBtnState = 'merge'

const initialState:IInitialState = {
    selectedGenericRadioBtn: defaultRadioBtnState
}

const genericRadioBtnSlice = createSlice({
    name: 'genericRadioBtn',
    initialState,
    reducers:{
        setGenericRadioBtn: ((state: IInitialState, action: PayloadAction<string>)=>{
            state.selectedGenericRadioBtn = action.payload;
        }),

        resetGenericRadioBtn: ((state: IInitialState)=>{
            state.selectedGenericRadioBtn = defaultRadioBtnState
            
        })
    }
})

export default genericRadioBtnSlice.reducer;
export const {setGenericRadioBtn, resetGenericRadioBtn} = genericRadioBtnSlice.actions;